if (!customElements.get('popup-add-modal')) {
    customElements.define(
      'popup-add-modal',
      class PopupAddModal extends ModalDialog {
        constructor() {
          super();
          this.modalContent = this.querySelector('[id^="PopupAddInfo-"]');
        }
  
        hide(preventFocus = false) {
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartNotification) cartNotification.setActiveElement(this.openedBy);
          
  
          if (preventFocus) this.openedBy = null;
          super.hide();
        }
  
        show(opener) {
          opener.setAttribute('aria-disabled', true);
          opener.classList.add('loading');
          const spinner = opener.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');

          Promise.resolve()
            .then(() => {
              super.show(opener);
              return new Promise((resolve) => requestAnimationFrame(resolve));
            })
            .finally(() => {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
            });
        }
  
        setInnerHTML(element, html) {
          element.innerHTML = html;
  
          // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
          element.querySelectorAll('script').forEach((oldScriptTag) => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
              newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
          });
        }
      }
    );
  }
  